export enum AdministratorIdentificationType {
  IDENTIFICATION_CARD = 1,
  RUC = 2,
  PASPORT = 3,
  CURP = 4, // Identificación México
  DNI_PERU = 5, // Identificación Perú
  DNI_COLOMBIA = 6, // Identificación Colombia
}

export const getAdministratorIdentificationType = (type: number): AdministratorIdentificationType => {
  switch (type) {
    case 1:
      return AdministratorIdentificationType.IDENTIFICATION_CARD;
    case 2:
      return AdministratorIdentificationType.PASPORT;
    case 3:
      return AdministratorIdentificationType.RUC;
    case 4:
      return AdministratorIdentificationType.CURP;
    case 5:
      return AdministratorIdentificationType.DNI_PERU;
    case 6:
      return AdministratorIdentificationType.DNI_COLOMBIA;
    default:
      return AdministratorIdentificationType.IDENTIFICATION_CARD;
  }
}